// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Zero layout height: the badge overflows vertically around the header's
   centerline, so it can be any size without making the header taller. */
.credits-badge-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 0;
  gap: 0.3rem;
  margin-right: auto;
  min-width: 0;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1;
  flex-shrink: 0;
}

.credits-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.44rem;
  min-width: 0;
  height: 2.1rem;
  padding: 0 0.72rem 0 0.5rem;
  border-radius: 8px;
  line-height: 1;
  color: #5b6472;
  background: rgba(229, 235, 241, 0.9);
  border: 1px solid rgba(186, 196, 208, 0.72);
  /* The header's padding is 1.5rem top / 1rem bottom, so the content line
     sits 0.25rem below the header's true middle — lift to compensate. */
  transform: translateY(-0.25rem);
}

.credits-badge__coin {
  width: 1.66rem;
  height: 1.66rem;
  flex-shrink: 0;
}

.credits-badge__coin-rim {
  stroke: #8a95a6;
}

.credits-badge__coin-spark {
  fill: #8a95a6;
}

.credits-badge__value {
  font-size: 1.14rem;
  font-weight: 600;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: #556171;
  letter-spacing: 0;
  transform: translateY(-1.5px);
}

/* Hover dropdown, same treatment as the account page's training-access note.
   The wrap is a 0-height box on the header centerline; the badge's bottom
   edge sits ~0.8rem below that line, so 1.2rem leaves a 0.4rem gap.
   The report panel is a 310px column with overflow: hidden, so the note
   must fit fully inside it: anything poking left or right of the panel
   would be clipped at the panel edge. 15.5rem from the badge's left edge
   stays inside even the narrow 270px responsive layout. */
.credits-badge__hover-note {
  position: absolute;
  top: 1.2rem;
  left: 0;
  z-index: 50;
  width: 15.5rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  background: rgba(248, 250, 252, 0.96);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  color: #475569;
  font-size: 0.85rem;
  line-height: 1.45;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-0.2rem);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
}

.credits-badge-wrap:hover .credits-badge__hover-note {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.credits-badge__hover-note-title {
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 700;
  color: #334155;
}

.credits-badge__value--infinity {
  font-size: 1.05rem;
}

.credits-badge--network-text {
  gap: 0.4rem;
}

.credits-badge--low {
  color: #9a6700;
  background: rgba(253, 246, 217, 0.94);
  border-color: rgba(229, 199, 123, 0.78);
}

.credits-badge--low .credits-badge__coin-rim {
  stroke: #b98a1c;
}

.credits-badge--low .credits-badge__coin-spark {
  fill: #b98a1c;
}

.credits-badge--low .credits-badge__value {
  color: #9a6700;
}

.credits-badge--empty {
  color: #7b8797;
  background: rgba(238, 242, 246, 0.96);
  border-color: rgba(188, 198, 208, 0.72);
}

.credits-badge--empty .credits-badge__coin-rim {
  stroke: #95a0ae;
}

.credits-badge--empty .credits-badge__coin-spark {
  fill: #95a0ae;
}

.credits-badge--empty .credits-badge__value {
  color: #7b8797;
}

.visually-hidden-credits {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ---- Dark theme ---- */

.dark .credits-badge {
  color: #d4dde8;
  background: rgba(36, 48, 60, 0.96);
  border-color: rgba(81, 96, 113, 0.72);
}

.dark .credits-badge__coin-rim {
  stroke: #c8d1dd;
}

.dark .credits-badge__coin-spark {
  fill: #c8d1dd;
}

.dark .credits-badge__value {
  color: #e3e9f1;
}

.dark .credits-badge__hover-note {
  border-color: rgba(75, 85, 99, 0.8);
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.35);
  color: rgba(226, 232, 240, 0.86);
}

.dark .credits-badge__hover-note-title {
  color: #e2e8f0;
}

.dark .credits-badge--low {
  color: #ffd978;
  background: rgba(74, 58, 24, 0.94);
  border-color: rgba(147, 116, 33, 0.74);
}

.dark .credits-badge--low .credits-badge__coin-rim {
  stroke: #ffd978;
}

.dark .credits-badge--low .credits-badge__coin-spark {
  fill: #ffd978;
}

.dark .credits-badge--low .credits-badge__value {
  color: #ffd978;
}

.dark .credits-badge--empty {
  color: #9ca3af;
  background: rgba(47, 57, 69, 0.96);
  border-color: rgba(81, 96, 113, 0.72);
}

.dark .credits-badge--empty .credits-badge__coin-rim {
  stroke: #8f99a6;
}

.dark .credits-badge--empty .credits-badge__coin-spark {
  fill: #8f99a6;
}

.dark .credits-badge--empty .credits-badge__value {
  color: #9ca3af;
}

@media (max-width: 1574px) {
  .credits-badge__hover-note {
    left: 0;
    right: auto;
    width: 12.25rem;
    font-size: 0.8rem;
    line-height: 1.38;
  }
}

@media (max-width: 1200px) {
  .credits-badge__hover-note {
    width: 10.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/report/CreditsBadge.css"],"names":[],"mappings":"AAAA;wEACwE;AACxE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,oCAAoC;EACpC,2CAA2C;EAC3C;wEACsE;EACtE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;;;0DAM0D;AAC1D;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,2EAA2E;AAC7E;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;;AAEzB;EACE,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,OAAO;IACP,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Zero layout height: the badge overflows vertically around the header's\n   centerline, so it can be any size without making the header taller. */\n.credits-badge-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 0;\n  gap: 0.3rem;\n  margin-right: auto;\n  min-width: 0;\n  cursor: default;\n  user-select: none;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.credits-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.44rem;\n  min-width: 0;\n  height: 2.1rem;\n  padding: 0 0.72rem 0 0.5rem;\n  border-radius: 8px;\n  line-height: 1;\n  color: #5b6472;\n  background: rgba(229, 235, 241, 0.9);\n  border: 1px solid rgba(186, 196, 208, 0.72);\n  /* The header's padding is 1.5rem top / 1rem bottom, so the content line\n     sits 0.25rem below the header's true middle — lift to compensate. */\n  transform: translateY(-0.25rem);\n}\n\n.credits-badge__coin {\n  width: 1.66rem;\n  height: 1.66rem;\n  flex-shrink: 0;\n}\n\n.credits-badge__coin-rim {\n  stroke: #8a95a6;\n}\n\n.credits-badge__coin-spark {\n  fill: #8a95a6;\n}\n\n.credits-badge__value {\n  font-size: 1.14rem;\n  font-weight: 600;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: #556171;\n  letter-spacing: 0;\n  transform: translateY(-1.5px);\n}\n\n/* Hover dropdown, same treatment as the account page's training-access note.\n   The wrap is a 0-height box on the header centerline; the badge's bottom\n   edge sits ~0.8rem below that line, so 1.2rem leaves a 0.4rem gap.\n   The report panel is a 310px column with overflow: hidden, so the note\n   must fit fully inside it: anything poking left or right of the panel\n   would be clipped at the panel edge. 15.5rem from the badge's left edge\n   stays inside even the narrow 270px responsive layout. */\n.credits-badge__hover-note {\n  position: absolute;\n  top: 1.2rem;\n  left: 0;\n  z-index: 50;\n  width: 15.5rem;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 10px;\n  background: rgba(248, 250, 252, 0.96);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);\n  color: #475569;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-0.2rem);\n  pointer-events: none;\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;\n}\n\n.credits-badge-wrap:hover .credits-badge__hover-note {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.credits-badge__hover-note-title {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-weight: 700;\n  color: #334155;\n}\n\n.credits-badge__value--infinity {\n  font-size: 1.05rem;\n}\n\n.credits-badge--network-text {\n  gap: 0.4rem;\n}\n\n.credits-badge--low {\n  color: #9a6700;\n  background: rgba(253, 246, 217, 0.94);\n  border-color: rgba(229, 199, 123, 0.78);\n}\n\n.credits-badge--low .credits-badge__coin-rim {\n  stroke: #b98a1c;\n}\n\n.credits-badge--low .credits-badge__coin-spark {\n  fill: #b98a1c;\n}\n\n.credits-badge--low .credits-badge__value {\n  color: #9a6700;\n}\n\n.credits-badge--empty {\n  color: #7b8797;\n  background: rgba(238, 242, 246, 0.96);\n  border-color: rgba(188, 198, 208, 0.72);\n}\n\n.credits-badge--empty .credits-badge__coin-rim {\n  stroke: #95a0ae;\n}\n\n.credits-badge--empty .credits-badge__coin-spark {\n  fill: #95a0ae;\n}\n\n.credits-badge--empty .credits-badge__value {\n  color: #7b8797;\n}\n\n.visually-hidden-credits {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ---- Dark theme ---- */\n\n.dark .credits-badge {\n  color: #d4dde8;\n  background: rgba(36, 48, 60, 0.96);\n  border-color: rgba(81, 96, 113, 0.72);\n}\n\n.dark .credits-badge__coin-rim {\n  stroke: #c8d1dd;\n}\n\n.dark .credits-badge__coin-spark {\n  fill: #c8d1dd;\n}\n\n.dark .credits-badge__value {\n  color: #e3e9f1;\n}\n\n.dark .credits-badge__hover-note {\n  border-color: rgba(75, 85, 99, 0.8);\n  background: rgba(15, 23, 42, 0.96);\n  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.35);\n  color: rgba(226, 232, 240, 0.86);\n}\n\n.dark .credits-badge__hover-note-title {\n  color: #e2e8f0;\n}\n\n.dark .credits-badge--low {\n  color: #ffd978;\n  background: rgba(74, 58, 24, 0.94);\n  border-color: rgba(147, 116, 33, 0.74);\n}\n\n.dark .credits-badge--low .credits-badge__coin-rim {\n  stroke: #ffd978;\n}\n\n.dark .credits-badge--low .credits-badge__coin-spark {\n  fill: #ffd978;\n}\n\n.dark .credits-badge--low .credits-badge__value {\n  color: #ffd978;\n}\n\n.dark .credits-badge--empty {\n  color: #9ca3af;\n  background: rgba(47, 57, 69, 0.96);\n  border-color: rgba(81, 96, 113, 0.72);\n}\n\n.dark .credits-badge--empty .credits-badge__coin-rim {\n  stroke: #8f99a6;\n}\n\n.dark .credits-badge--empty .credits-badge__coin-spark {\n  fill: #8f99a6;\n}\n\n.dark .credits-badge--empty .credits-badge__value {\n  color: #9ca3af;\n}\n\n@media (max-width: 1574px) {\n  .credits-badge__hover-note {\n    left: 0;\n    right: auto;\n    width: 12.25rem;\n    font-size: 0.8rem;\n    line-height: 1.38;\n  }\n}\n\n@media (max-width: 1200px) {\n  .credits-badge__hover-note {\n    width: 10.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
